// extracted by mini-css-extract-plugin
export default {"container":"container-NC35dUXs","imageContainer":"imageContainer-n0Zwn1QL","image":"image-iIz62eEi","text":"text-YjYQ0BDr"};